import { axiosInstance } from "./BaseService" 

export async function doLogin(email, password) {
  try {
    const response = await axiosInstance.post('/login', { email, password });
    return response.data;
  } catch(err) {
    throw err.response?.status || 500;
  }
}

export async function doLogout() {
  try {
    const response = await axiosInstance.post('/auth/logout', {});
    return response.data;
  } catch(err) {
    throw err.response?.status || 500;
  }
}

export async function refreshToken() {
  try {
    const response = await axiosInstance.post('/auth/refresh-token', {});
    return response.data;
  } catch(err) {
    throw err.response?.status || 500;
  }
}